/*
    ByHouseRoom  By Uncle Julius' House
    Pic Workshop
    Hints 2512
    InformOnEntry Uncle Julius spends most of his time in his laboratory, the second door on the left. It's in a separate building so that he doesn't accidentally blow up his house.
    RoomFlag 2
    RoomScriptBox STUDY 13   74 43 166 DOOR
    RoomScriptBox LAB   116 111 14 94  DOOR
*/

function ByHouseRoom(game) {

    this.Room_constructor(game, 'byhouse');
    this.birds = new BirdSong(this);
}

createjs.extend(ByHouseRoom, Room);

ByHouseRoom.prototype.preload =
    function () {
        this.manifest =
            this.makeManifest(this.id, ['#scene', 'lab-frames', 'study-frames'].concat(this.birds.entityManifestSpec()));

        this.Room_preload(this.manifest);
    };

ByHouseRoom.prototype.load =
    function () {
        this.Room_load();

        this.birds.entityLoad();

        /* The wall graphic slides rightward as you walk */
        this.loadDoors();

        return this;
    };

ByHouseRoom.prototype.enter =
    function () {
        this.Room_enter(
            'Uncle Julius spends most of his time in his laboratory, the second door on the left. ' +
            'It’s in a separate building so that he doesn’t accidentally blow up his house.'
        );

        this.birds.sing();

        return this;
    };

ByHouseRoom.prototype.leave =
    function (nextKey) {
        this.Room_leave(nextKey);
        this.birds.hush();
    };

ByHouseRoom.prototype.next =
    function (nextKey) {
        if (nextKey == 'lab')
            return new BusRideRoom(this.world);
        else if (nextKey == 'study')
            return new StudyRoom(this.world);
    };

ByHouseRoom.prototype.loadDoors =
    function () {
        var artLabDoorFrameData = {
            images: [this.world.queue.getResult('byhouse-lab-frames')],
            frames: {width: 15, height: 91, count: 2},
            animations: {closed: 0, open: 1}
        };

        var artStudyDoorFrameData = {
            images: [this.world.queue.getResult('byhouse-study-frames')],
            frames: {width: 41, height: 159, count: 2},
            animations: {closed: 0, open: 1}
        };

        var labState = this.data('labOpen');
        var studyState = this.data('studyOpen');

        this.artLabFrames = new createjs.SpriteSheet(artLabDoorFrameData);
        this.artStudyFrames = new createjs.SpriteSheet(artStudyDoorFrameData);

        this.artLab = ujPut(new createjs.Sprite(this.artLabFrames, labState ? 'open' : 'closed'), 116, 115, 'labDoor');
        this.artStudy = ujPut(new createjs.Sprite(this.artStudyFrames, studyState ? 'open' : 'closed'), 13, 82, 'studyDoor');

        this.artLab.gameCursor = labState ? 'left' : 'action';
        this.artStudy.gameCursor = studyState ? 'left' : 'action';

        this.artLab.on('click', function () {
            if (this.data('labOpen'))
                this.leave('lab');
            else {
                this.data('labOpen', true);
                this.artLab.gotoAndStop('open');
                this.artLab.gameCursor = 'left';
                this.resetCursor();
            }
        }, this);

        this.artStudy.on('click', function () {
            if (this.data('studyOpen'))
                this.leave('study');
            else {
                this.data('studyOpen', true);
                this.artStudy.gotoAndStop('open');
                this.artStudy.gameCursor = 'left';
                this.resetCursor();
            }
        }, this);

        this.reg(this.artLab);
        this.reg(this.artStudy);
    };

createjs.promote(ByHouseRoom, 'Room');
